var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutubeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.45,
    height: 20,
    viewBox: "0 0 26.45 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(-245.6 -295.385)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M245.6,303.015c.034-.548.072-1.1.1-1.645a10.927,10.927,0,0,1,.414-2.719,3.965,3.965,0,0,1,3.687-2.961c1.2-.11,2.4-.152,3.607-.2q5.948-.235,11.894.047a29.866,29.866,0,0,1,3.008.226,3.958,3.958,0,0,1,3.314,3.185,19.259,19.259,0,0,1,.368,3.818,59.886,59.886,0,0,1-.167,7.941,5.441,5.441,0,0,1-1,2.835,3.637,3.637,0,0,1-2.641,1.49c-1.481.128-2.969.2-4.455.261-3.724.158-7.449.093-11.171-.061a27.327,27.327,0,0,1-3.387-.3,3.781,3.781,0,0,1-3.164-3.1,18.477,18.477,0,0,1-.36-3.4c-.013-.2-.034-.408-.051-.612Zm13.8-6.12c-2.434.059-4.284.09-6.132.152-1.126.038-2.253.093-3.374.193a2.4,2.4,0,0,0-2.234,1.7,9.046,9.046,0,0,0-.4,2.484,68.694,68.694,0,0,0-.044,7.069,13.591,13.591,0,0,0,.341,3.095,2.3,2.3,0,0,0,1.876,1.827,6.572,6.572,0,0,0,.865.132c1.434.077,2.869.153,4.3.205,2.959.107,5.918.121,8.876,0,1.521-.063,3.043-.128,4.558-.263a2.156,2.156,0,0,0,1.9-1.492,8.4,8.4,0,0,0,.455-2.577,68.911,68.911,0,0,0,.044-7.095,12.694,12.694,0,0,0-.344-3.12,2.567,2.567,0,0,0-.845-1.409,3.207,3.207,0,0,0-1.887-.6C264.505,297.08,261.66,296.98,259.4,296.895Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M398.362,384.857c0-1.015,0-2.031,0-3.046a1.083,1.083,0,0,1,1.705-1q2.807,1.53,5.608,3.072a1.07,1.07,0,0,1,.38,1.718,1.482,1.482,0,0,1-.391.289q-2.8,1.512-5.609,3.015a1.083,1.083,0,0,1-1.693-1.023C398.36,386.87,398.362,385.864,398.362,384.857Zm5.914.018L399.93,382.5v4.714Z",
    transform: "translate(-142.902 -79.734)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtubeIcon.12255879b4403d3a0ead708d69737920.svg";
export { ForwardRef as ReactComponent };